import { PumpAnimatic, PumpAnimaticProps } from '@crossnokaye/ux-animatics';

import { AnimaticPumpConfigOrientation } from '@repo/sdk/models/components';

import { ANIMATIC_PRIMARY_LABEL } from '@/features/equipment-browser/animatics/constants';
import { getLabel } from '@/features/equipment-browser/animatics/helpers';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticPump = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const flip = config.specificAnimaticConfig?.pump?.flip ?? false;
  const orientation = (config.specificAnimaticConfig?.pump?.orientation ??
    AnimaticPumpConfigOrientation.Horizontal) as PumpAnimaticProps['orientation'];
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <PumpAnimatic
        flip={flip}
        label={primaryLabel?.text}
        orientation={orientation}
        state={state}
      />
    </ScaledAnimatic>
  );
};
